// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---KnCvq","marginBottom0":"marginBottom0---T68ZT","marginTop0":"marginTop0---U93aC"};